import extractPropertyFromState from './extractPropertyFromState';
/**
 * Detect whether form has any errors
 * @param  {Record} state - App state
 * @param  {string} name - onion form name
 * @return {boolean} true when form has error
 */

export default function hasErrors(state, name) {
  var errors = Object.values(extractPropertyFromState(state, name, 'error'));
  return errors.filter(function (e) {
    return e && e.length > 0;
  }).length > 0;
}